import { Injectable } from '@angular/core';
import { Headers, RequestOptions } from '@angular/http';
import { HttpClient } from '@angular/common/http';

import { WP_API_URL } from 'app/config';

import { AgrupadorDocumentos, Documento } from 'models/documento';

export const DOCUMENTOS_API_URL = WP_API_URL + '/documentos';

@Injectable()
export class DocumentosService {

  private options = new RequestOptions({
    headers: new Headers({ 'Content-Type': 'application/json' }),
  });

  constructor(private http: HttpClient) { }

  private query(params: any): Promise<AgrupadorDocumentos[]> {
    const url = DOCUMENTOS_API_URL;
    const reqParams = Object.assign({}, { '_embed': true, 'per_page': 15 }, params);
    const filtro = {
      params: reqParams,
      options: this.options,
    };

    return new Promise<AgrupadorDocumentos[]>((resolve, reject) => {
      this.http.get<any>(url, filtro).subscribe(
        output => {

          let groups: AgrupadorDocumentos[] = [];
          if (output && output.length > 0) {
            groups = output.map(group => {
              let docs: Documento[] = [];
              if (group.documentos) {
                docs = group.documentos.map(doc => new Documento(doc));
              }

              const mappedGroup = new AgrupadorDocumentos(group);
              mappedGroup.documentos = docs;
              return mappedGroup;
            });
          }

          resolve(groups);
        },
        err => {
          reject(err);
        });
    });
  }

  queryManuaisEditais(): Promise<AgrupadorDocumentos[]> {
    return this.query({ 'filter[document_type]': 'manuais-editais' });
  }

  queryResultadosMedicina(): Promise<AgrupadorDocumentos[]> {
    return this.query({ 'filter[document_type]': 'resultado-medicina' });
  }

  queryDocumentosCPA(): Promise<AgrupadorDocumentos[]> {
    return this.query({ 'filter[document_type]': 'documentos-cpa' });
  }

  queryResultadosCPA(): Promise<AgrupadorDocumentos[]> {
    return this.query({ 'filter[document_type]': 'resultados-cpa' });
  }

  queryRegulamentosCPA(): Promise<AgrupadorDocumentos[]> {
    return this.query({ 'filter[document_type]': 'regulamentos-da-cpa' });
  }

  queryResultadosAutoavaliacaoCPA(): Promise<AgrupadorDocumentos[]> {
    return this.query({ 'filter[document_type]': 'resultados-autoavaliacao-cpa' });
  }

  queryDocumentosCondOfertaCurso(): Promise<AgrupadorDocumentos[]> {
    return this.query({ 'filter[document_type]': 'documentos-cond-oferta-curso' });
  }

  queryCurriculosPlanosPedagogicos(): Promise<AgrupadorDocumentos[]> {
    return this.query({ 'filter[document_type]': 'curriculos-planos-pedagogicos' });
  }

  queryInstitucionaisPlanosPedagogicos(): Promise<AgrupadorDocumentos[]> {
    return this.query({ 'filter[document_type]': 'documentos-institucionais'});
  }

  queryTutorialRapidoBiblioteca(slug): Promise<AgrupadorDocumentos[]> {
    return this.query({'filter[document_type]': slug});
  }

  queryEditaisPosGraduacao(slugEdital): Promise<AgrupadorDocumentos[]> {
    return this.query({ 'filter[document_type]': slugEdital });
  }

  queryProducoesTecnicas(): Promise<AgrupadorDocumentos[]>{
    return this.query({ 'filter[document_type]': 'producoes-tecnicas'});
  }

  queryProvasAplicadas(): Promise<AgrupadorDocumentos[]>{
    return this.query({ 'filter[document_type]': 'provas-aplicadas'});
  }

  queryFiesProuni(): Promise<AgrupadorDocumentos[]>{
    return this.query({ 'filter[document_type]': 'prouni'})
  }

  queryPPC(): Promise<AgrupadorDocumentos[]>{
    return this.query({ 'filter[document_type]': 'ppc'})
  }

  queryPPI(): Promise<AgrupadorDocumentos[]>{
    return this.query({ 'filter[document_type]': 'politicas-de-propriedade-intelectual'})
  }

  queryPoliticasDePropriedadeIntelectual(): Promise<AgrupadorDocumentos[]> {
    return this.query({ 'filter[document_type]': 'politicas-de-propriedade-intelectual'});
  }
}
